var map = {
	"./AMD.svg": 55716,
	"./ARS.svg": 9438,
	"./AZN.svg": 58563,
	"./BDT.svg": 34612,
	"./BTC.svg": 6299,
	"./BWP.svg": 30065,
	"./DASH.svg": 23370,
	"./DOGE.svg": 95713,
	"./ETH.svg": 28983,
	"./IDR.svg": 8665,
	"./INR.svg": 70859,
	"./KES.svg": 45085,
	"./KGS.svg": 2755,
	"./KRW.svg": 66984,
	"./KZT.svg": 55907,
	"./LTC.svg": 48293,
	"./PKR.svg": 79593,
	"./RUB.svg": 74617,
	"./TJS.svg": 34415,
	"./TRX.svg": 58604,
	"./TRX_USDT.svg": 72607,
	"./USDC.svg": 80069,
	"./USDT.svg": 50090,
	"./USDT_ERC20.svg": 81169,
	"./USDT_TRC20.svg": 61552,
	"./UZS.svg": 35962,
	"./XAF.svg": 22799,
	"./XRP.svg": 63112,
	"./ZAR.svg": 21605,
	"./unknown.svg": 95708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11286;